export const fronttabs = {
  items: [
    {
      link: "/oferta/szukaj.xml?top=12&extern=1&sort=3&order=DESC&dojazd=samolot&pobyt=6,8&adt=2&panstwo=GR,MG,BG,CI,BA,TK,IT,ES,CY&MTO=ITAK,ITAG,VITX,VITG&tourOp=ITAK,ITAG,VITX,VITG&TO=ITAK,ITAG,VITX,VITG",
      linkb: "",
      nazwa: "Hity",
      pozycja: "1",
      tytul: "Hity tygodnia",
      grafika: "popularne",
      text: "Najpopularniejsze<br />wczasy tygodnia",
      textcolor: "light",
      buttontext: "Przeglądaj oferty",
    },
    {
      link: "/oferta/szukaj.xml?top=12&extern=1&sort=0&dojazd=samolot&pobyt=6,8&adt=2&panstwo=GR,MG,BG,CI,BA,TK,IT,ES,CY&termin=2025-05-01&dni=150",
      linkb: "/last-minute/oferty.xml?dojazd=samolot&pobyt=6,14",
      nazwa: "Lato",
      pozycja: "2",
      tytul: "Lato 2025",
      grafika: "lato",
      text: "Wczasy i wycieczki <br />na lato 2025!",
      textcolor: "dark",
      buttontext: "Przejdź do ofert",
    },
    {
      link: "/oferta/szukaj.xml?top=12&extern=1&sort=0&dojazd=wlasny&noMTO=NPL,NDAM,TUIZ&pobyt=6,8&adt=2&panstwo=GR,MG,BG,CI,BA,TK,IT,ES,CY",
      linkb: "/rodzaj-oferty/all-inclusive-wyspykanaryjskie.xml",
      nazwa: "Dojazd własny",
      pozycja: "3",
      tytul: "Dojazd własny",
      grafika: "dojazd-wlasny",
      text: "Sprawdź oferty<br />z dojazdem własnym!",
      textcolor: "dark",
      buttontext: "Przejdź do ofert",
    },
    {
      link: "/oferta/szukaj.xml?top=12&extern=1&dojazd=samolot&adt=2&panstwo=BL,CN,AE,HA,IN,KR,KE,MD,MY,MU,MX,ZA,SC,SL,TH,VE,CV&MTO=ITAK,ITAG,VITX,VITG&tourOp=ITAK,ITAG,VITX,VITG&TO=ITAG,ITAK,VITX,VITG",
      linkb: "/rodzaj-oferty/all-inclusive-wyspykanaryjskie.xml",
      nazwa: "Egzotyka",
      pozycja: "4",
      tytul: "Egzotyka",
      grafika: "egzotyka",
      text: "Sprawdź oferty<br />na&nbsp;egzotyczne wakacje!",
      textcolor: "light",
      buttontext: "Przejdź do ofert",
    },
  ],
};
